import { useCallback } from 'react';
import { useDocumentAPI } from './useDocumentAPI';
import type { InstructorAssessmentExportData } from '../types/instructor-assessment-export';

export interface UseWordExportInstructorAssessmentOptions {
  onExportStart?: () => void;
  onExportSuccess?: (blob: Blob, filename: string) => void;
  onExportError?: (error: Error) => void;
}

export interface UseWordExportInstructorAssessmentReturn {
  exportInstructorAssessmentToWord: (data: InstructorAssessmentExportData) => Promise<Blob>;
  isExporting: boolean;
  error: Error | null;
}

export function useWordExportInstructorAssessment(
  options: UseWordExportInstructorAssessmentOptions = {},
): UseWordExportInstructorAssessmentReturn {
  const { generateDocument, isExporting, error } = useDocumentAPI(options);

  const exportInstructorAssessmentToWord = useCallback(
    async (data: InstructorAssessmentExportData): Promise<Blob> => {
      const instructorName = data.partA.instructor.name || 'Unknown';
      const sessionDate = (data.partA.sessionDate || new Date().toISOString().slice(0, 10)).replace(/\//g, '-');
      const defaultFilename = `WingMentor_Instructor_Assessment_${sessionDate}_${instructorName.replace(/\s+/g, '_')}.docx`;
      return generateDocument('instructor-assessment', 'docx', data as unknown as Record<string, unknown>, defaultFilename);
    },
    [generateDocument],
  );

  return { exportInstructorAssessmentToWord, isExporting, error };
}
